import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useRoleMappingsFetch = (id: string) => {
  const response = useQuery({
    queryKey: ['roleMappings', id],
    queryFn: () => api.keycloak.fetchUserRoleMappings(id),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить карту ролей пользователя',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
